var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSend(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_9961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6567 12.3433C51.3519 12.0384 50.9042 11.9256 50.4913 12.0494L14.6412 22.8045C13.0614 23.2784 12 24.705 12 26.3549C12 27.9819 13.0926 29.4304 14.6571 29.8775L29.7969 34.2031L34.1225 49.3429C34.5695 50.9073 36.018 52 37.6457 52C39.295 52 40.7216 50.9386 41.1955 49.3587L51.9505 13.5086C52.0745 13.0957 51.9616 12.6481 51.6567 12.3433V12.3433ZM14.3438 26.3543C14.3438 25.748 14.7339 25.2236 15.3147 25.0494L46.7128 15.63L30.4037 31.939L15.3009 27.624C14.7374 27.4629 14.3438 26.9411 14.3438 26.3543V26.3543ZM38.9506 48.6853C38.7764 49.2661 38.252 49.6562 37.6451 49.6562C37.0589 49.6562 36.5371 49.2626 36.3761 48.699L32.061 33.5962L48.3701 17.2872L38.9506 48.6853Z",
    fill: "#1F3232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_9961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1cde40ce73e73626a83942dff808fc49.svg";
export { ForwardRef as ReactComponent };